module.exports = __webpack_public_path__ + "static/kvet_cb@2x-53631ced342b073027cfad43e56ebaad.png";